import { get } from 'lodash';

export const sortAlphabeticallyByKeys = (sortKeys: string[], a: any, b: any): number => {
  const aText = sortKeys
    .map(key => get(a, key))
    .join(' ')
    .toUpperCase();

  const bText = sortKeys
    .map(key => get(b, key))
    .join(' ')
    .toUpperCase();

  return aText > bText ? 1 : bText > aText ? -1 : 0;
};

export const toMap = (list: any[]) =>
  list.reduce(
    (acc, curr, idx) => ({
      ...acc,
      [idx]: curr
    }),
    {}
  );
